import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import amber from '@material-ui/core/colors/amber';
import AddIcon from '@material-ui/icons/Add';

import * as routes from 'constants/routes';
import { displayAcceptMission, startMission, saveCompletedMission } from 'store/actions/help';
import { startEditAdmin } from 'store/actions/admin';
import { illustrations } from 'components/Illustration';
import AppStructure from 'img/AppStructure.png';
import MissionIcon from 'img/icons8-rocket-96.png';

const styles = theme => ({
  button: {
    backgroundColor: amber[500],
    '&:hover': {
      backgroundColor: amber[700],
    },
  },
  fab: {
    backgroundColor: amber[500],
    '&:hover': {
      backgroundColor: amber[700],
    },
  },
});


class Intro extends Component {
  state = {
    currentStep: 0,
  };


  render() {
    const {
      classes,
      history,
      name,
      showDialog,
      startMission,
      startEditAdmin,
      displayAcceptMission,
    } = this.props;
    const { currentStep } = this.state;

    return (
      <Dialog
        open={showDialog}
        className={classes.root}
      >
        <DialogContent>
          <div style={{ width: '510px', height: '500px' }}>
            {currentStep === 0 &&
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                  style={{ marginTop: '30px', marginBottom: '30px', alignSelf: 'center' }}
                  variant="title"
                >
                  {`Welcome ${name}!`}
                </Typography>
                <Typography
                  style={{ marginBottom: '20px' }}
                >
                  Let's discover how Couraggo manages your busy work; from daily paperwork and reminders to a website showing the world what you can do.
                </Typography>
                <Typography
                >
                  Our goal is to provide administrative tools so you can focus on your work.
                </Typography>
                <img
                  style={{
                    width: '250px',
                    height: '250px',
                    alignSelf: 'center',
                    marginTop: '10px',
                    marginBottom: '10px',
                  }}
                  alt=""
                  src={illustrations.get("empty_amber")} />
                <div style={{ alignSelf: 'center', marginBottom: '30px' }}>
                  <Button
                    color="primary"
                    onClick={() => this.setState({ currentStep: (currentStep + 1) })}
                    variant="contained"
                  >
                    Let's open the box!
                  </Button>
                </div>

              </div>

            }

            {currentStep === 1 &&
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                  style={{ marginTop: '30px', marginBottom: '30px', alignSelf: 'center' }}
                  variant="title"
                >
                  The Basics...
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <div>
                    <Typography
                      style={{ marginBottom: '10px' }}
                    >
                      The Floating Action Button!
                    </Typography>
                    <Typography>
                      This button will be there when you need to add stuff...
                    </Typography>
                  </div>
                  <Button
                    style={{ marginLeft: '30px' }}
                    className={classes.fab}
                    variant="fab"
                  >
                    <AddIcon />
                  </Button>
                </div>
                <div style={{
                    marginBottom: '30px', marginTop: '30px',
                    display: 'flex', flexDirection: 'row' }}>
                  <img
                    style={{ width: '210px', height: '210px', marginRight: '30px' }}
                    src={AppStructure}
                    alt="App Structure"
                  />
                  <div>
                    <Typography style={{ marginBottom: '30px', }}>
                      Many areas will have three sections
                    </Typography>
                    <Typography style={{ marginBottom: '10px' }}>
                      1. Main Menu
                    </Typography>
                    <Typography style={{ marginBottom: '10px' }}>
                      2. Cards of Invoices, Receipts, etc...
                    </Typography>
                    <Typography style={{ marginBottom: '10px' }}>
                      3. Our innovative Help Panel
                    </Typography>
                  </div>
                </div>
                <div style={{ alignSelf: 'center', marginBottom: '30px' }}>
                  <Button
                    color="primary"
                    onClick={() => this.setState({ currentStep: (currentStep + 1) })}
                    variant="contained"
                  >
                    Up for a Fun Challenge?
                  </Button>
                </div>

              </div>

            }

            {currentStep === 2 &&
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                  style={{ marginTop: '30px', marginBottom: '30px', alignSelf: 'center' }}
                  variant="title"
                >
                  Your mission, if you chose to accept...
                </Typography>
                <div style={{
                    marginTop: '30px',
                    marginBottom: '70px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                  <Typography style={{ maxWidth: '300px' }}>
                    Couraggo has several missions where you'll learn stuff AND setup your business!
                  </Typography>
                  <img
                    style={{ width: '100px', height: '100px' }}
                    alt=""
                    src={illustrations.get("mission_impossible_amber")} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Button
                      style={{ marginBottom: '10px' }}
                      onClick={() => {
                        displayAcceptMission("website-1");
                        //saveCompletedMission("intro-1");
                        // history.push(routes.WEBSITE);
                        // startMission("website-1");
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Mission 1: Build your website!
                    </Button>
                    <Typography
                      style={{ alignSelf: 'center', marginBottom: '10px' }}
                    >
                    OR
                    </Typography>
                    <Button
                      onClick={() => {
                        displayAcceptMission("invoice-1");
                        // saveCompletedMission("intro-1");
                        // startEditAdmin({ invoice: null });
                        // history.push(routes.INVOICES);
                        // startMission("invoice-1");
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Mission 2: Do a quickie invoice
                    </Button>
                  </div>
                  <div style={{ alignSelf: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>

                      <Typography
                        style={{ marginLeft: '30px', maxWidth: '175px' }}
                      >
                        Note: You’ll find more missions in our Mission button; top right of page
                      </Typography>
                      <img
                        style={{ marginRight: '10px', width: '35px', height: '35px' }}
                        src={MissionIcon}
                        alt="Missions"
                      />
                    </div>
                  </div>

                </div>
              </div>
            }
          </div>

        </DialogContent>
        {currentStep > 0 &&
          <DialogActions>
            <div style={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
              <Button
                onClick={() => this.setState({ currentStep: (currentStep - 1) })}
              >
                Back
              </Button>
              {currentStep === 2 &&
                <Button
                  onClick={() => saveCompletedMission("intro-1")}
                >
                  Skip
                </Button>
              }
            </div>
          </DialogActions>
        }

      </Dialog>
    );
  }
}

Intro.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = state => {
  const { user, organizations } = state.accountState;
  const profile = user ? user.profile : {};
  const organization = organizations[0] ? organizations[0] : {};
  const about = organization.about ? organization.about : {};
  const missions = state.help.missions.filter(mission => mission.type === "intro");
  let showDialog = true;
  missions.forEach(mission => {
    if(mission.isCompleted) {
      showDialog = false;
    }
  });

  return ({
    name: profile.username,
    showDialog,
  });
}

const mapDispatchToProps = {
  startMission,
  startEditAdmin,
  displayAcceptMission
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Intro);



// WEBPACK FOOTER //
// ./src/components/admin/Help/Intro.jsx